import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as SharedStyle from '../../shared-style';

//http://www.cssportal.com/css-tooltip-generator/

const STYLE = {
  width: '60px',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '5px',
  fontSize: '25px',
  backgroundColor:"#ff5d17",
  position: 'relative',
  cursor: 'pointer'
};

const BASE_STYLE_TOOLTIP={
  position: 'absolute',
  width: '140px',
  color: SharedStyle.COLORS.white,
  background: SharedStyle.COLORS.black,
  height: '30px',
  lineHeight: '30px',
  textAlign: 'center',
  visibility: 'visible',
  borderRadius: '6px',
  opacity: '0.8',
  top: '50%',
  marginTop: '-15px',
  marginLeft: '15px',
  zIndex: '999',
  fontSize: '12px'
}
const STYLE_TOOLTIP_LEFT = {
  right: '100%',
};
const STYLE_TOOLTIP_RIGHT = {
 
  left: '100%',
 
};
const BASE_STYLE_TOOLTIP_PIN={
  position: 'absolute',
  top: '50%',
  marginTop: '-8px',
  width: '0',
  height: '0',
  borderTop: '8px solid transparent',
  borderBottom: '8px solid transparent'
}
const STYLE_TOOLTIP_PIN_LEFT = {
  right: '100%',
  borderRight: '8px solid #000000',
};
const STYLE_TOOLTIP_PIN_RIGHT = {
  left: '100%',
  borderLeft: '8px solid #000000',
};

export default class ToolbarButton extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = { active: false, rtl:props.hasOwnProperty("rtl")? props.rtl : false };
  }

  render() {
    let { state, props } = this;
    let color = props.active || state.active ? SharedStyle.SECONDARY_COLOR.icon : "white";
    return (
      <div style={{...STYLE, ...(props.hasOwnProperty("styles")?props.styles:{})}}
        onMouseOver={event => this.setState({ active: true })}
        onMouseOut={event => this.setState({ active: false })}>
        <div style={{ color }} onClick={props.onClick}>
          {props.children}
        </div>

        {
          state.active
           ?
          <div style={{...BASE_STYLE_TOOLTIP, ...(state.rtl?STYLE_TOOLTIP_RIGHT:STYLE_TOOLTIP_LEFT)}}>
            <span style={{...BASE_STYLE_TOOLTIP_PIN, ...(state.rtl?STYLE_TOOLTIP_PIN_LEFT:STYLE_TOOLTIP_PIN_RIGHT)}} />
            {props.tooltip}
          </div>
          : null
        }

      </div>
    )
  }
}

ToolbarButton.propTypes = {
  active: PropTypes.bool.isRequired,
  tooltip: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  rtl: PropTypes.bool.isRequired
};
